import _defineProperty from "/app/node_modules/babel-runtime/helpers/defineProperty";
import _extends from "/app/node_modules/babel-runtime/helpers/extends";
import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";

var _fetch$data$component;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import VueRecaptcha from "vue-recaptcha";
import { required, minLength } from "vuelidate/lib/validators";
import comisions from "@/components/shared/table/comisions-table";
import template from "@/components/stepper/functionals/autocomplete-template";
import { solutionName } from "~/enums";
import { WarningError } from "@/abstractions/errors";
import loader from "@/components/modals/loader";
export default (_fetch$data$component = {
  fetch: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          app = _ref.app,
          params = _ref.params;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              store.commit("dashboard/details/setToolbarTitle", "Previsualización de Comisiones");

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetch(_x) {
      return _ref2.apply(this, arguments);
    }

    return fetch;
  }(),
  data: function data() {
    var sitekey = process.env.recatpchaSiteKey;
    return {
      template: template,
      solutionName: solutionName,
      ruc: '',
      solucion: '',
      giro: '',
      today: this.$moment().format('LL'),
      sitekey: sitekey,
      captchaToken: '',
      expiredCaptchaToken: false,
      isRecaptchaLoaded: false,
      buttonDisabled: false,
      loading: false,
      product: '',
      subProduct: '',
      mccInternacional: '',
      commercialBusiness: '',
      errorMessage: '',
      showMessage: false,
      showTableComision: false,
      barHeight: 550,
      barWidth: 970
    };
  },


  components: {
    comisions: comisions,
    loader: loader
  },
  computed: _extends({}, mapState({
    user: function user(state) {
      return state.user;
    },
    notificationCount: function notificationCount(state) {
      return state.notification.notificationCount;
    },
    opCommercialBusiness: function opCommercialBusiness(state) {
      return state["master-data"].opCommercialBusiness;
    }
  }), mapGetters('user', ['isAdmin', 'isBoss', 'isSeller', 'isSupervisor']), {
    onResize: function onResize() {
      if (window.innerWidth <= 1024 && window.innerWidth > 768) {
        this.barWidth = 1100;
        this.barHeight = 100;
      } else if (window.innerWidth <= 1200 && window.innerWidth > 1024) {
        this.barWidth = 1100;
        this.barHeight = 200;
      } else if (window.innerWidth <= 768 && window.innerWidth > 650) {
        this.barWidth = 1100;
        this.barHeight = 400;
      } else if (window.innerWidth <= 600 && window.innerWidth > 480) {
        this.noContent = true;
        this.barHeight = 400;
      } else if (window.innerWidth <= 480) {
        this.noContent = true;
        this.barHeight = 590;
      } else {}
    }
  })
}, _defineProperty(_fetch$data$component, "components", {
  'vue-recaptcha': VueRecaptcha
}), _defineProperty(_fetch$data$component, "validations", {
  ruc: {
    required: required,
    minLength: minLength(11)
  },
  solucion: {
    required: required
  },
  giro: {
    required: required
  },
  captchaToken: {
    required: required
  }
}), _defineProperty(_fetch$data$component, "methods", {
  onSubmit: function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var responseCreateLogComission, _ref4, success, _ref4$content, code, message, data, _ref5, codigo, mensaje;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this.showMessage = false;
              this.showTableComision = false;

              this.$refs.loaderModal.showLoader();
              _context2.prev = 3;
              _context2.next = 6;
              return this.$store.dispatch("affiliations/form/createLogComission");

            case 6:
              responseCreateLogComission = _context2.sent;

              console.log("responseCreateLogComission ", responseCreateLogComission);
              _context2.next = 10;
              return this.$store.dispatch("affiliations/form/consultarCliente", { ruc: this.ruc });

            case 10:
              _ref4 = _context2.sent;
              success = _ref4.success;
              _ref4$content = _ref4.content;
              code = _ref4$content.code;
              message = _ref4$content.message;

              if (success) {
                _context2.next = 21;
                break;
              }

              this.showMessage = true;
              this.errorMessage = "message";
              this.$refs.loaderModal.closeLoader();
              this.showTableComision = false;
              return _context2.abrupt("return");

            case 21:
              data = {
                audit: {
                  appId: "PCRM001V1",
                  usuario: "",
                  ipServidor: "",
                  transaccionId: "",
                  origen: ""
                },
                obtenerComisionesRequest: {
                  cliente: {
                    ruc: this.ruc,
                    oportunidad: {
                      producto: this.product,
                      subProducto: this.subProduct,
                      mccInternacional: this.mccInternacional,
                      plataforma: ""
                    }
                  }
                }
              };
              _context2.next = 24;
              return this.$store.dispatch("affiliations/form/newConsultComision", data);

            case 24:
              _ref5 = _context2.sent;
              codigo = _ref5.codigo;
              mensaje = _ref5.mensaje;

              if (!(codigo !== "0000")) {
                _context2.next = 35;
                break;
              }

              if (mensaje) {
                _context2.next = 33;
                break;
              }

              this.$refs.loaderModal.closeLoader();
              throw new WarningError("El servicio no se encuentra disponible.");

            case 33:
              this.$refs.loaderModal.closeLoader();
              throw new WarningError(mensaje);

            case 35:
              _context2.next = 43;
              break;

            case 37:
              _context2.prev = 37;
              _context2.t0 = _context2["catch"](3);

              this.$refs.loaderModal.closeLoader();
              console.log(_context2.t0);
              this.$swal("Error", "" + _context2.t0.data.message, "error");
              console.log(_context2.t0);

            case 43:
              this.$refs.loaderModal.closeLoader();
              this.showTableComision = true;

            case 45:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[3, 37]]);
    }));

    function onSubmit() {
      return _ref3.apply(this, arguments);
    }

    return onSubmit;
  }(),
  validarRucCliente: function validarRucCliente(ruc) {
    console.log("RUC -> ", ruc);
  },
  listenerAutocomplete: function listenerAutocomplete() {
    // console.log("val");
  },
  onVerify: function onVerify(response) {
    this.captchaToken = response;
    this.expiredCaptchaToken = false;
  },
  onExpired: function onExpired() {
    this.expiredCaptchaToken = true;
  },
  resetCaptchaValue: function resetCaptchaValue() {
    this.$refs.recaptcha.reset();
    this.captchaToken = '';
    this.expiredCaptchaToken = false;
  },
  selectSolucion: function selectSolucion(event) {
    console.log(event);

    var _solutionName$find = solutionName.find(function (obj) {
      return obj.name === event;
    }),
        code = _solutionName$find.code,
        name = _solutionName$find.name,
        subCode = _solutionName$find.subCode;

    this.product = code;
    this.subProduct = subCode;
  },
  consultGiro: function consultGiro(event) {
    console.log(event);
    this.mccInternacional = event;
  },
  consultSolucion: function consultSolucion(event) {

    console.log(event);
    // this.product = code
    // this.subProduct = subCode
  }
}), _defineProperty(_fetch$data$component, "created", function created() {}), _fetch$data$component);


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/commisionPreviewer.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/commisionPreviewer.vue
// module chunks = 17